
import {map} from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { RestService } from '../../shared/providers/rest.service';
import { IBrokerageInput } from '../../shared/models/Brokerageinputmodel';
import { IBrokergaCreationalResponseModel } from '../../shared/models/BrokerageCreationResponseModel';
import { IBrokerageBrokerInput } from '../../shared/models/BrokerageBrokerInputModel';
import { AuthenticationService } from '../auth/authentication.service';
import { HttpClient } from '@angular/common/http';
import { IUpdateTimestampModel } from '../models/IUpdateTimestampModel';


@Injectable()
export class BrokerageManagerService extends RestService {
    brokerageInputModel = {} as IBrokerageInput;
    brokerageCreationalResponseModel = {} as IBrokergaCreationalResponseModel
    constructor(private Authentication: AuthenticationService, protected http: HttpClient) {
        super(http);
    }

    // create new brokerage
    createBrokerage(iBrokerageInput: IBrokerageInput) {
        let url = "/brokerage/create";
        return this.postForEntityObject<IBrokergaCreationalResponseModel>(url, iBrokerageInput).pipe(
            map(response => {
                this.brokerageCreationalResponseModel = response;
                return this.brokerageCreationalResponseModel;
            }));
    }


    // update new brokerage
    updateBrokerage(iBrokerageInput: IBrokerageInput) {
        let url = "/brokerage/update";
        return this.postForEntityObject<IBrokergaCreationalResponseModel>(url, iBrokerageInput).pipe(
            map(response => {
                this.brokerageCreationalResponseModel = response;
                return this.brokerageCreationalResponseModel;
            }));
    }

    // create new broker
    createBroker(iBrokerageBrokerInput: IBrokerageBrokerInput) {
        let url = "/brokerage/createbroker";
        return this.postForEntityObject<IBrokergaCreationalResponseModel>(url, iBrokerageBrokerInput).pipe(
            map(response => {
                this.brokerageCreationalResponseModel = response;
                return this.brokerageCreationalResponseModel;
            }));
    }

    //Update modified Date of Property
    UpdateDataEntryPropertyTimeStamp(propertyId: number) {
        let user: any = this.Authentication.user;
        let url = "brokerage/updateTimeStamp/" + propertyId + "/" + user.Id;
        return this.post(url, '');
    }
    //Update modified Date of Property
  UpdatePropertyTimeStamp(updateTimestamp: IUpdateTimestampModel) {
        let user: any = this.Authentication.user;
        let url = "property/updateTimeStamp";
    return this.post(url, updateTimestamp);
    }

    VerifyProperty(propertyId: number) {
        let user: any = this.Authentication.user;
        let url = "brokerage/VerifyProperty/" + propertyId + "/" + user.Id;;
        return this.post(url, '');
    }

    // update new broker
    updateBroker(iBrokerageBrokerInput: IBrokerageBrokerInput) {
        let url = "/brokerage/updatebroker";
        return this.postForEntityObject<IBrokergaCreationalResponseModel>(url, iBrokerageBrokerInput).pipe(
            map(response => {
                this.brokerageCreationalResponseModel = response;
                return this.brokerageCreationalResponseModel;
            }));
    }

    // Gets the list of states
    getBrokerageList() {
        return this.GET('brokerage/brokerages');
    }
    // Method to get the brokerages of user
    getBrokerageDetails(brokerageId: number) {
        return this.get("brokerage/getBrokerageDetails/" + brokerageId);
    }

    // Method to get the brokerages of user
    getBrokerDetails(brokerId: number) {
        return this.GET("brokerage/getBrokerDetails/" + brokerId);
    }

    // Method to get the count of brokers inside a brokerage
    getBrokersByBrokerage(brokerageId: number) {
        return this.GET("brokerage/getBrokersByBrokerage/" + brokerageId);
    }
    // Method to get the details of brokers inside a brokerage
    getBrokerDetailsByBrokerage(brokerageId: number) {
        return this.GET("brokerage/getBrokerDetailsByBrokerage/" + brokerageId);
    }
    //Delete Brokerage
    deleteBrokerage(brokerageId: number, userId: number) {
        let url = "brokerage/deleteBrokerage?brokerageId=" + brokerageId + "&userId=" + userId;
        return this.GET(url);
    }

    //Delete Broker
    deleteBroker(brokerId: number, type: number = 1) {
        let url = "brokerage/deleteBroker/" + brokerId + "/" + type;
        return this.post(url, '');
    }

    AddBEStaffToBrokerage(stafFID: number, brokerageId: number) {
        return this.post("brokerage/AddBEStaffToBrokerage/" + stafFID + "/" + brokerageId,'');
    }

    GetPropertyBrokerage(propertyId: number) {
        return this.GET("brokerage/GetPropertyBrokerage/" + propertyId);
    }
}
